import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { first } from 'lodash';
import { AgGridReact } from 'ag-grid-react';
import {
  FormGroup, FormControl, ControlLabel,
  PanelGroup, Panel,
} from 'react-bootstrap';
import Fa from 'react-fontawesome';

import {
  delay, each, map, find,
} from 'lodash';
import SearchField from '../../../../components/search-field';

const TYPE = 'accordion';

class ContactTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeKey: first(props.contacts) ? first(props.contacts)._id : null,
    };
    this.onGridReady = this.onGridReady.bind(this);
    this.onFirstDataRendered = this.onFirstDataRendered.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.buyerRoleValueGetter = this.buyerRoleValueGetter.bind(this);
    this.buyerTypeValueGetter = this.buyerTypeValueGetter.bind(this);
    this.priorityValueGetter = this.priorityValueGetter.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.onFirstDataRendered();
  }

  onFirstDataRendered() {
    if (this.gridApi && this.gridColumnApi) {
      this.gridApi.showLoadingOverlay();
      delay(() => {
        const { width } = this.props;
        const allColumns = this.gridColumnApi.getColumns();
        const allColumnIds = map(allColumns, 'colId');
        this.gridColumnApi.autoSizeColumns(allColumnIds);
        let allWidths = 0;
        each(this.gridColumnApi.getColumns(), (col) => {
          allWidths += col.actualWidth;
        });
        const viewableWidth = width;
        if (allWidths < viewableWidth - 2) {
          this.gridApi.sizeColumnsToFit();
        }
        this.gridApi.hideOverlay();
      }, 500);
    }
  }

  handleSelect(activeKey) {
    this.setState({ activeKey });
  }
  handleSearch(query) {
    if (this.gridApi) {
      this.gridApi.setQuickFilter(query);
    }
  }

  buyerRoleValueGetter(params) {
    if (!params || !params.data) {
      return null;
    }
    const r = params.data.buyer_role;
    if (r) {
      const { program } = this.props;
      const initiatives = program.initiatives || {};
      const buyerRoles = initiatives.buyerRoles || [];
      const role = find(buyerRoles, { id: r });
      return role ? role.name : r;
    }
    return null;
  }

  buyerTypeValueGetter(params) {
    if (!params || !params.data) {
      return null;
    }
    const r = params.data.buyer_type;
    if (r) {
      const { program } = this.props;
      const initiatives = program.initiatives || {};
      const buyerTypes = initiatives.buyerTypes || [];
      const type = find(buyerTypes, { id: r });
      return type ? type.name : r;
    }
    return null;
  }

  priorityValueGetter(params) {
    if (!params || !params.data) {
      return null;
    }
    const r = params.data.priority;
    if (r) {
      const { program } = this.props;
      const initiatives = program.initiatives || {};
      const priorities = initiatives.priorities || [];
      const priority = find(priorities, { id: r });
      return priority ? priority.name : r;
    }
    return null;
  }

  renderTable() {
    const { contacts } = this.props;
    const rowHeight = 34;
    const tableHeight = (rowHeight * (contacts.length + 1)) + (rowHeight + 2);
    const columnDefs = [
      {
        headerName: 'Contact',
        colId: 'NAME',
        suppressMenu: true,
        suppressMovable: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
        width: 120,
        pinned: 'left',
        valueGetter: (params) => {
          if (!params || !params.data) {
            return null;
          }
          return `${params.data.first_name} ${params.data.last_name}`;
        },
      },
      {
        headerName: 'Title',
        colId: 'TITLE',
        width: 100,
        field: 'title',
      },
      {
        headerName: 'Email',
        colId: 'EMAIL',
        width: 100,
        field: 'email',
      },
      {
        headerName: 'Phone',
        colId: 'PHONE',
        width: 100,
        valueGetter: (params) => {
          if (!params || !params.data) {
            return null;
          }
          const p = params.data.phone;
          if (params.data.phone_extension && params.data.phone_extension.length > 0) {
            return `${p} (${params.data.phone_extension})`;
          }
          return p;
        },
      },
      {
        headerName: 'Mobile',
        colId: 'MOBILE',
        width: 100,
        field: 'mobile_phone',
      },
      {
        headerName: 'Country',
        colId: 'COUNTRY',
        width: 100,
        field: 'mailing_address.country',
      },
      {
        headerName: 'Priority',
        colId: 'PRIORITY',
        width: 100,
        valueGetter: this.priorityValueGetter,
      },
      {
        headerName: 'Buyer Role',
        colId: 'ROLE',
        width: 100,
        field: 'buyer_role',
        valueGetter: this.buyerRoleValueGetter,
      },
      {
        headerName: 'Buyer Type',
        colId: 'TYPE',
        width: 100,
        valueGetter: this.buyerTypeValueGetter,
      },
      {
        headerName: 'Tags',
        colId: 'TAGS',
        width: 100,
        field: 'tags',
      },
      {
        headerName: 'Notes',
        colId: 'NOTES',
        width: 100,
        field: 'notes',
      },
    ];


    return (
      <div>
        {contacts.length >= 5 &&
          <nav className="navbar navbar-default navbar-controls">
            <div className="navbar-form navbar-left">
              <SearchField onSearch={this.handleSearch} />
            </div>
          </nav>
        }
        <div className="ag-theme-alpine" style={{ width: '100%', height: tableHeight }}>
          <AgGridReact
            reactNext
            enableColResize
            enableSorting
            animateRows
            suppressColumnVirtualisation
            columnDefs={columnDefs}
            getRowId={({ data }) => data.id}
            onGridReady={this.onGridReady}
            rowData={contacts}
            rowSelection="multiple"
            onSelectionChanged={this.onSelectionChanged}
            rowHeight={rowHeight}
            defaultColDef={{
              suppressMenu: true,
              suppressMovable: true,
              suppressColumnsToolPanel: true,
              suppressFiltersToolPanel: true,
            }}
          />
        </div>
      </div>
    );
  }

  renderField(label, value, cls = 'col-sm-6', componentClass = 'input') {
    return (
      <div className={cls}>
        <FormGroup>
          <ControlLabel>{label}</ControlLabel>
          <FormControl componentClass={componentClass} type="text" disabled readOnly value={(value || 'N/A')} />
        </FormGroup>
      </div>
    );
  }

  renderAccordion() {
    const { contacts } = this.props;
    const { activeKey } = this.state;
    return (
      <div>
        <PanelGroup activeKey={activeKey} onSelect={this.handleSelect} accordion>
          {contacts.map((contact) => {
            const isActive = contact._id === activeKey;
            return (
              <Panel
                key={contact._id}
                eventKey={contact._id}
              >
                <Panel.Heading>
                  <Panel.Title>
                    <Panel.Toggle componentClass="div">
                      <table>
                        <tbody>
                          <tr>
                            <td width="99%" className="text-active" style={{ cursor: 'pointer' }}>
                              <span style={{ color: '#222' }}>
                                {contact.first_name} {contact.last_name}
                              </span>
                            </td>
                            <td style={{ verticalAlign: 'top', paddingLeft: 10 }}><Fa name={isActive ? 'caret-up' : 'caret-down'} /></td>
                          </tr>
                        </tbody>
                      </table>
                    </Panel.Toggle>
                  </Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible>
                  <div>
                    <div className="row">
                      {this.renderField('First Name', contact.first_name)}
                      {this.renderField('Last Name', contact.last_name)}
                    </div>

                    <div className="row">
                      {this.renderField('Title', contact.title)}
                      {this.renderField('Email', contact.email)}
                    </div>

                    <div className="row">
                      {this.renderField('Phone', contact.phone)}
                      {this.renderField('Extension', contact.phone_extension)}
                    </div>

                    <div className="row">
                      {this.renderField('Mobile', contact.mobile_phone)}
                      {this.renderField('Country', contact.mailing_address ? contact.mailing_address.country : null)}
                    </div>

                    <div className="row">
                      {this.renderField('Contact priority', this.priorityValueGetter({ data: contact }), 'col-sm-12')}
                    </div>

                    <div className="row">
                      {this.renderField('Buyer Role', this.buyerRoleValueGetter({ data: contact }))}
                      {this.renderField('Buyer Type', this.buyerTypeValueGetter({ data: contact }))}
                    </div>

                    <div className="row">
                      {this.renderField('Applied Tags', contact.tags ? contact.tags.join(', ') : 'N/A', 'col-sm-12')}
                    </div>

                    <div className="row">
                      {this.renderField('Notes', contact.notes, 'col-sm-12', 'textarea')}
                    </div>

                  </div>
                </Panel.Body>
              </Panel>
            );
          })}
        </PanelGroup>
      </div>
    );
  }

  render() {
    const { contacts } = this.props;
    if (contacts.length === 0) {
      return (
        <div className="alert alert-warning">No records found.</div>
      );
    }

    if (TYPE === 'table') {
      return this.renderTable();
    }
    return this.renderAccordion();
  }
}

ContactTable.propTypes = {
  contacts: PropTypes.arrayOf(PropTypes.shape({})),
  program: PropTypes.shape({}).isRequired,
  width: PropTypes.number,
};
ContactTable.defaultProps = {
  contacts: [],
  width: 0,
};


export default ContactTable;
